import { Api } from '@/services/Api'

export default {
  getHeaderData(data) {
    return Api().post('./api/v2/header', data)
  },
  fetchTrackerTableData(data) {
    return Api().post('./api/v2/tracker/table', data)
  },
  fetchTrackerGraphData(data) {
    return Api().post('./api/v2/tracker/graph', data)
  }
}
